import React, { useEffect, useState } from "react";
import { Container, TabPane, TabContent } from "reactstrap";
import classnames from 'classnames';

import { Star, TrendingUp } from "react-feather";

import Loader from "~/components/loader";
import User   from "~/services/user";

import OfferCard               from "./Cards/Offer";
import DragonHitTournamentCard from "./Cards/DragonHitTournament";
import GameCard                from "./Cards/Game";
import ReferralCard            from "./Cards/Referral";
import CheckInCard             from "./Cards/CheckIn";
import PromotionCard           from "./Cards/Promotion";
import BonusCard               from "./Cards/Bonus";
import TaskCard                from "./Cards/Task";

import HistoryTab  from './HistoryTab'
import SurveyCard  from "./Cards/Survey";
import ContestCard from "./Cards/Contest";
import BetCard     from "./Cards/Bet";
import CashbackCard from "./Cards/Cashback";
import GameRecordCard from "./Cards/GameRecord";

const WalletPage = ()=> {

  const [isLoading , setIsLoading] = useState(true);
  const [latest    , setLatest]    = useState([]);
  const [tab       , setTab]       = useState('latest');

  const getCard = (item)=> {
    let cards =  {
      offer               : OfferCard,
      survey              : SurveyCard,
      checkIn             : CheckInCard,
      referral            : ReferralCard,
      dragonHitTournament : DragonHitTournamentCard,
      gameTransactions    : GameCard,
      promotion           : PromotionCard,
      bonus               : BonusCard,
      task                : TaskCard,
      contest             : ContestCard,
      bet                 : BetCard,
      cashback            : CashbackCard,
      gameRecord          : GameRecordCard
    }

    return React.createElement(cards[item.selector], {item});
  };

  useEffect(async ()=> {
    await User.history().then((data)=> {
      setLatest([]
          .concat(data.completedOffers.map((item)=>   { item.selector = 'offer'             ; return item}))
          .concat(data.completedSurveys.map((item)=>  { item.selector = 'survey'            ; return item}))
          .concat(data.referralsPoints.map((item)=>   { item.selector = 'referral'          ; return item}))
          .concat(data.gamesTransactions.map((item)=> { item.selector = 'gameTransactions'  ; return item}))
          .concat(data.checkIns.map((item)=>          { item.selector = 'checkIn'           ; item.createdAt = item.claimedAt; return item}))
          .concat(data.promoRewards.map((item)=>      { item.selector = 'promotion'         ; item.createdAt = item.claimedAt; return item}))
          .concat(data.gamesRewards.map((item)=>      { item.selector = 'dragonHitTournament';return item}))
          .concat(data.bonusClaim.map((item)=>        { item.selector = 'bonus'             ; item.createdAt = item.claimedAt; return item}))
          .concat(data.tasksClaims.map((item)=>       { item.selector = 'task'              ; item.createdAt = item.claimedAt; return item}))
          .concat(data.contestsWinned.map((item)=>    { item.selector = 'contest'           ; return item}))
          .concat(data.betsClaims.map((item)=>        { item.selector = 'bet'               ; return item}))
          .concat(data.cashbacksClaims.map((item)=>   { item.selector = 'cashback'          ; item.createdAt = item.updatedAt; return item}))
          .concat(data.recordsClaims.map((item)=>     { item.selector = 'gameRecord'        ; return item}))
          .sort((a,b)=> (new Date(b.createdAt).getTime()) - (new Date(a.createdAt).getTime()))
      );
   });

    setIsLoading(false);
  }, []);

  if(isLoading) return <Loader type={19} center />;

  return (
    <Container className="wallet-page">

      <h1 className="main-title"> Wallet </h1>


      <div className="tab-switcher gray">
        <p className={classnames({"selected": tab == 'latest' })} onClick={()=> setTab('latest')  }> <TrendingUp /> Latest  </p>
        <p className={classnames({"selected": tab == 'history' })} onClick={()=> setTab('history') }><Star /> History </p>
      </div>

      <TabContent activeTab={tab} className="m-t-40">
        <TabPane className="fade show" tabId="latest">
          { !latest.length && !isLoading && (
            <div className="text-center text-muted">
              <h4>No offers completed </h4>
              <p> Complete an offer and start earning rewards. </p>
            </div>
          )}

          { latest.map((item)=> <div className="wallet-item" key={`${item.id}${item.createdAt}`}> { getCard(item) } </div>) }
        </TabPane>

        <TabPane tabId="history"> <HistoryTab /> </TabPane>
      </TabContent>
    </Container>
  );
}

export default WalletPage;
